import { render, staticRenderFns } from "./MovieSeriesContentList.vue?vue&type=template&id=5b44231a"
import script from "./MovieSeriesContentList.vue?vue&type=script&lang=js"
export * from "./MovieSeriesContentList.vue?vue&type=script&lang=js"
import style0 from "./MovieSeriesContentList.vue?vue&type=style&index=0&id=5b44231a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports